






















































import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Emit
} from 'vue-property-decorator'
import _ from 'lodash'
import {
  SearchAPI,
  SearchResultResponse,
  TournamentSearchIndex
} from '@/api/search'
import ServerError from '@/utils/server_error'
import { getModule } from 'vuex-module-decorators'
import layoutStore from '@/modules/shared/layout.store'
import tournamentStore from '@/modules/tournament/tournament.store'

export enum SearchMode {
  All = 'all',
  Tournaments = 'tournaments'
}

@Component
export default class SearchResult extends Vue {
  layoutModule = getModule(layoutStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)
  debouncedSearch = _.debounce(this.search, 500)

  mode: SearchMode = SearchMode.All
  page: number = 1
  hasMoreData: boolean = true
  result: SearchResultResponse | null = null
  tournamentSearchResult: TournamentSearchIndex[] = []

  @PropSync('searching', { default: false })
  isSearching!: boolean

  @Prop({ default: '' })
  readonly query!: string

  @Watch('query')
  onQueryChanged(query: string) {
    if (query === '') {
      return
    }

    this.debouncedSearch()
    this.isSearching = true
  }

  created() {
    this.search()
  }

  get tournamentSearchIndices(): TournamentSearchIndex[] {
    switch (this.mode) {
      case SearchMode.All:
        if (!this.result) return []
        return this.result.tournaments

      case SearchMode.Tournaments:
        return this.tournamentSearchResult
    }

    return []
  }

  get hasNoResult() {
    return this.tournamentSearchIndices.length === 0
  }

  async search() {
    if (this.query === '') {
      this.isSearching = false
      return
    }

    this.isSearching = true

    try {
      let res

      switch (this.mode) {
        case SearchMode.All:
          res = await SearchAPI.searchAll(this.query)
          this.result = res.data.payload as SearchResultResponse
          break

        case SearchMode.Tournaments:
          res = await SearchAPI.searchTournaments(this.query)
          this.tournamentSearchResult = res.data
            .payload as TournamentSearchIndex[]
          break
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('SearchResult.SystemErrorMessage'))
      }

      console.error(err)
    } finally {
      this.isSearching = false
      this.page = 1
      this.hasMoreData = true
    }
  }

  async navigateToTournament(tournamentId: string) {
    await this.tournamentModule.setSelectedTournament(tournamentId)
    this.$router.push({
      name: 'TournamentDetailsOverview',
      params: {
        tournamentId
      }
    })

    this.layoutModule.setSearchDialogVisible(false)
  }

  setTournamentMode() {
    this.mode = SearchMode.Tournaments
    this.search()
  }

  async onScroll(event: Event) {
    const el = event.target as HTMLDivElement

    if (
      el.scrollTop < (el.scrollHeight - el.clientHeight) * 0.5 ||
      !this.hasMoreData ||
      this.isSearching
    )
      return

    if (this.mode === SearchMode.Tournaments) {
      this.isSearching = true

      try {
        const res = await SearchAPI.searchTournaments(this.query, ++this.page)
        const data = res.data.payload as TournamentSearchIndex[]

        if (data.length === 0) {
          this.hasMoreData = false
        }

        this.tournamentSearchResult = [...this.tournamentSearchResult, ...data]
      } catch (err) {
        if (err instanceof ServerError) {
          this.$toast.error(err.getMessage())
        } else {
          this.$toast.error(this.$t('SearchResult.SystemErrorMessage'))
        }

        console.error(err)
        this.hasMoreData = false
      } finally {
        this.isSearching = false
      }
    }
  }

  reset() {
    this.result = null
    this.mode = SearchMode.All
    this.page = 1
    this.hasMoreData = true
  }
}
